module.exports = __webpack_public_path__ + "static/media/button4.c06154f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/game/scene1/asset/button4.png
// module id = 1779
// module chunks = 0